import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "DATA PREP 28%",
  "MODEL DEVELOPMENT 26%",
  "DEPLOYMENT 22%",
  "MONITORING & SECURITY 24%",
  "65 QUESTIONS",
  "170 MINUTES",
  "PASS AT 720 / 1000",
];

export function TopMarquee() {
  return (
    <div className="relative z-10 border-y border-[var(--border-heavy)] bg-[#1C2430] text-[#FBFBF9] py-3" data-testid="marquee">
      <Marquee speed={30} gradient={false}>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span key={i} className="font-mono-ui text-[11px] uppercase tracking-[0.28em] mx-8 flex items-center">
            {t}
            <span className="ml-8 text-[#2F6F4F]">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
